module.exports = __webpack_public_path__ + "img/battery-groupe-no-number.fa04641b.svg";